import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { homeFor } from '../lib/roles';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b7bb9a58-a668-4de2-aa2e-f5e39e6e614e/artifacts/buijzrp9_App%20Icon%20Yellow.png";

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');

    const result = await login(email, password);
    
    if (result.success) {
      navigate(homeFor(result.user?.role));
    } else {
      setErrorMessage(result.error);
    }
    
    setIsLoading(false);
  };

  return (
    <div className="login-container" data-testid="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img 
            src={LOGO_URL} 
            alt="Mayo Logo" 
            className="h-16 w-16 rounded-xl"
            data-testid="login-logo"
          />
        </div>

        {/* Heading */}
        <h1 
          className="text-2xl font-bold text-center text-[#111111] mb-8"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          Mayo Team
        </h1>

        {/* Error Message */}
        {errorMessage && (
          <div 
            className="mb-4 p-3 bg-red-50 border border-[#D32F2F] rounded-md text-[#D32F2F] text-sm"
            data-testid="login-error"
          >
            {errorMessage}
          </div>
        )}

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label 
              htmlFor="email" 
              className="text-[#111111] font-medium text-sm"
            >
              Email
            </Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              data-testid="login-email-input"
              className="border-[#E0E0E0] bg-[#F5F5F5] focus:ring-[#FF6B35] focus:border-[#FF6B35] text-[#111111] placeholder:text-[#666666]"
            />
          </div>

          <div className="space-y-2">
            <Label 
              htmlFor="password" 
              className="text-[#111111] font-medium text-sm"
            >
              Password
            </Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              data-testid="login-password-input"
              className="border-[#E0E0E0] bg-[#F5F5F5] focus:ring-[#FF6B35] focus:border-[#FF6B35] text-[#111111] placeholder:text-[#666666]"
            />
          </div>

          <Button
            type="submit"
            disabled={isLoading}
            data-testid="login-submit-button"
            className="w-full bg-[#FF6B35] hover:bg-[#e55a2b] text-white font-medium py-2 rounded-md transition-colors mt-6"
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                Signing in...
              </span>
            ) : (
              'Sign In'
            )}
          </Button>
        </form>

        <div className="text-center mt-6">
          <Link
            to="/forgot-password"
            data-testid="login-forgot-password-link"
            className="text-sm text-[#FF6B35] hover:text-[#e55a2b] font-medium"
          >
            Forgot password?
          </Link>
        </div>
      </div>
    </div>
  );
}
